import { useQuery } from '@tanstack/react-query';
import { getSeatsIOEvent, SeatsIOEvent } from 'services/Seats';

export const useGetSeatsIOEvent = (eventKey: string | null | undefined) => {
	return useQuery<SeatsIOEvent>({
		queryKey: ['seatsIOEvent', eventKey],
		queryFn: () => {
			if (!eventKey) throw new Error('Event key is required');
			return getSeatsIOEvent(eventKey);
		},
		enabled: !!eventKey,
		staleTime: 5 * 60 * 1000,
		cacheTime: 10 * 60 * 1000,
	});
};
